import { getApiClient } from '@treneo/infrastructure/api';

import { AuthApi } from './auth.api';

export * from './auth.api';
export const authApi = new AuthApi(getApiClient());
